import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

import { IonicModule } from '@ionic/angular';

import {ChooseDoctorComponent} from "./choose-doctor.component";
import {ChooseDoctorRoutingModule} from "./choose-doctor-routing.module";
import {CustomModule} from "../customs/custom.module";
import { CustomSearchModule } from '../../custom-search-bar.module';
import { ChooseDoctorListModalComponent } from '../choose-doctor-list-modal/choose-doctor-list-modal.component';
import { ChooseDoctorListModalModule } from '../choose-doctor-list-modal/choose-doctor-list-modal.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    TranslateModule,    
    ChooseDoctorRoutingModule,
      CustomModule,
      CustomSearchModule,
      ChooseDoctorListModalModule
  ],
  declarations: [ChooseDoctorComponent]
})
export class ChooseDoctorModule {}
